import React from 'react';
import axios from 'axios';
import Footer from '../../Footer'
import renderHTML from 'react-render-html';
import Navbar from '../../Navbar';
import Preloader from "../../Preloader";
import {
  WORDPRESS_URL,
  WP_POSTS_SLUG,
  WP_POSTS_SLUG_WITH_FEATUREDMEDIA
} from "../../../utils/constants";
import { Redirect } from 'react-router-dom';
import defaultBg from '../../../images/bg-new2.jpg';
import $ from "jquery";
require('lightbox2');

class Detail extends React.Component{

    constructor(props){
        super(props);

        this.state = {
            post: {
                idx: "",
                title: "",
                text: "", 
                shortText: "",
                slug: "",
                date: "",
                featuredMedia: `url("${defaultBg}")`
            },
            backgroundImage: "",
            isLoading: true, 
            error: {},
            redirectInternalError: false
        }
    }


    handleBack = () => {
        const { history } = this.props;
        if (document.referrer && document.referrer.includes(window.location.hostname)) {
          history.goBack();
        } else {
          history.push('/'); // nebo jiná stránka
        }
      };
      
    componentDidMount(){
        const slug = this.props.match.params.slug;        

        axios.get( WORDPRESS_URL + WP_POSTS_SLUG_WITH_FEATUREDMEDIA + slug)
        .then(res => {
            if (res.data[0] !== undefined) {
                // let featuredMediaLinks = res.data[0]._embedded['wp:featuredmedia'] ? res.data[0]._embedded['wp:featuredmedia'] : null;
                // let featuredMediaLink = featuredMediaLinks ? `url("${featuredMediaLinks[0].source_url}")` : `url("${defaultBg}")`; // rest api na získání úvodního obrázku
                            
                let post = {
                    idx: res.data[0].id,
                    title: res.data[0].title.rendered,
                    text: res.data[0].content.rendered, 
                    shortText: res.data[0].excerpt.rendered,
                    slug: res.data[0].slug,
                    date: res.data[0].date,
                    // featuredMedia: featuredMediaLink
                }

                let categories = res.data[0].categories;
 // Získání podrobností o kategoriích
 const categoryPromises = categories.map(id =>
                axios.get( WORDPRESS_URL + '/wp-json/wp/v2/categories/' +id)
                .then(res2 => res2.data)
            );
            
            Promise.all(categoryPromises)
              .then(categories => {
                categories.map(category => {
                    switch(category.slug){
                        case 'o-spolecnosti':
                            this.setState({backgroundImage:"company-header"});
                            break;
                        case 'reference':
                            this.setState({backgroundImage:"reference-header"});
                            break;
                            case 'dodavka-technologickych-konstrukci':
                                this.setState({backgroundImage:"dtk-header"});
                                break;
                                case 'dodavka-velkych-stavebnich-ocelovych-konstrukci':
                                    this.setState({backgroundImage:"dvsok-header"});
                                    break;
                                    case 'vyroba-obecnych-ocelovych-svarencu':
                                        this.setState({backgroundImage:"voos-header"});
                                        break;
                                        case 'zakazkove-obrabeni':
                                            this.setState({backgroundImage:"zo-header"});
                                            break;
                                            case 'hydraulika':
                                                this.setState({backgroundImage:"hydraulika-header"});
                                                break;
                                                case 'asr-elektro':
                                                    this.setState({backgroundImage:"asr-elektro-header"});
                                                    break;
                                                case 'projekty-na-klic':
                                                    this.setState({backgroundImage:"projects-on-key-header"});
                                                    break;
                                                    case 'kontakty':
                                                        this.setState({backgroundImage:"contact-header"});
                                                        break;
                                                        case 'spolecnost':
                                                            this.setState({backgroundImage:"company-header"});
                                                            break;
                                                            case 'fotovoltaika':
                                                                this.setState({backgroundImage:"fotovoltaika-header"});
                                                                break;
                        default:
                            break;
                    }
                });

                if(this.state.backgroundImage === ""){
                    this.setState({backgroundImage:"detail-header-bg",
                        post: post,
                            isLoading: false
                    });
                    }
                    else{
                        this.setState({
                            post: post,
                            isLoading: false
                        });
                    }
                
              });

                
            } else {
                this.setState({
                    isLoading: false
                });

                this.props.history.push('/404');
            } 
        })
        .catch( error => {
            console.log(error);

            this.setState({ 
                error: error, 
                isLoading: false,
                redirectInternalError: true
            });                    
        });
    }

    renderHeader = () => {
        const { post, backgroundImage } = this.state;

        return(
            <header className={"detail-header " + backgroundImage}>
                <div className="header-overlay">
                <Navbar/>
        
        
                <div className="sd-container ">
                <section id="section-sub-header">
                            <div className="col-md-12 d-flex justify-content-between section-title"> 
                                    <div className="d-flex justify-content-between align-items-center">
                                        <h6 className="sub-header-caption text-uppercase title-border-radius link">{renderHTML(post.title)}</h6>
                                    </div>
                                <span className='back-button link' onClick={this.handleBack}><i className='fa ml-2 fa-chevron-left'></i> Zpět</span>          
                            </div>                        
                    </section>
                </div>
                </div>
            </header> 
        );
    }

    renderMainContainer = () => {
        const { post } = this.state;

        return(
            <section id="main-container">
                <div className="sd-container">
        
                    <div className="detail-content detail-content-padding">
                        <div className="detail-title mb-4">
                        <h5 className='font-weight-bold mb-3'>
                                {renderHTML(post.shortText)}
                            </h5>
                        </div>
        
                        <div className="detail-text">  
                            {renderHTML(post.text)}
                        </div>
                    </div>
                    
                </div>
            </section>
        );
    }

    renderFooter = () => {
        return(
            <footer className="footer-section-height">
                <div className="sd-container">
                    <section id="footer-content" className="footer-top-padding footer-top-padding-contact">
                        <Footer/>
                    </section>
                </div>
            </footer>            
        );
    }

    render(){
        const { isLoading, redirectInternalError, error } = this.state;

        return (            
            <section id="web">
                {isLoading ? (
                    <Preloader isLoaded={!isLoading} />
                    ) : (redirectInternalError ? (
                        <Redirect to={{
                            pathname: "/500",
                            state: { error: error }
                          }} />
                ) : ( 
                    <div className="wrapper">
                        {this.renderHeader()}

                        {this.renderMainContainer()}

                        {this.renderFooter()}
                    </div>
                ))}
            </section>        
        )
    }
}

export default Detail;